import { Timezone } from '@/entities'

import { utcToZonedTime } from './utcToZonedTime'
import { zonedTimeToUtc } from './zonedTimeToUtc'

export const dateOnly = (date: Date, timezone?: Timezone) => {
    const dateInTimezone = timezone ? utcToZonedTime(date, timezone) : date

    return new Date(
        Date.UTC(dateInTimezone.getFullYear(), dateInTimezone.getMonth(), dateInTimezone.getDate(), 0, 0, 0, 0)
    )
}

export const dateOnlyToDateTime = (dateOnly: Date, dayTime: 'start' | 'end', timezone?: Timezone): Date => {
    return zonedTimeToUtc(
        new Date(
            dateOnly.getUTCFullYear(),
            dateOnly.getUTCMonth(),
            dateOnly.getUTCDate(),
            dayTime === 'start' ? 0 : 23,
            dayTime === 'start' ? 0 : 59,
            dayTime === 'start' ? 0 : 59,
            dayTime === 'start' ? 0 : 999
        ),
        timezone
    )
}

export const validateIsDateOnly = (date: Date): boolean => {
    return (
        date.getUTCHours() === 0 &&
        date.getUTCMinutes() === 0 &&
        date.getUTCSeconds() === 0 &&
        date.getUTCMilliseconds() === 0
    )
}

export const validateIsDateOnlyThrow = (date: Date | null | undefined, arg: string): void => {
    if (!date) {
        return
    }

    if (!validateIsDateOnly(date)) {
        throw new Error(`Invalid date only provided for ${arg}`)
    }
}
